"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/*
 * Types
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyPosition = exports.JaqlSortDirection = exports.DataType = exports.DateLevels = exports.MetadataTypes = exports.Sort = exports.AggregationTypes = void 0;
/**
 * Different aggregation types
 */
exports.AggregationTypes = {
    /** Sum aggregation type */
    Sum: 'sum',
    /** Average aggregation type */
    Average: 'avg',
    /** Min aggregation type */
    Min: 'min',
    /** Max aggregation type */
    Max: 'max',
    /** Count aggregation type */
    Count: 'count',
    /** Count distinct aggregation type */
    CountDistinct: 'countDistinct',
    /** Median aggregation type */
    Median: 'median',
    /** Variance aggregation type */
    Variance: 'var',
    /** Standard deviation aggregation type */
    StandardDeviation: 'stdev',
};
/**
 * Different sort types.
 */
var Sort;
(function (Sort) {
    /** No sort definition  */
    Sort[Sort["None"] = 0] = "None";
    /** Sort Ascending */
    Sort[Sort["Ascending"] = 1] = "Ascending";
    /** Sort Descending */
    Sort[Sort["Descending"] = 2] = "Descending";
})(Sort = exports.Sort || (exports.Sort = {}));
/**
 * Different metadata types
 *
 * @internal
 */
exports.MetadataTypes = {
    Measure: 'measure',
    MeasureTemplate: 'measuretemplate',
    BaseMeasure: 'basemeasure',
    CalculatedMeasure: 'calculatedmeasure',
    Dimension: 'dimension',
    DateDimension: 'datedimension',
    TextDimension: 'textdimension',
    NumericDimension: 'numericdimension',
    DateLevel: 'datelevel',
    Attribute: 'attribute',
    TextAttribute: 'text-attribute',
    NumericAttribute: 'numeric-attribute',
    Filter: 'filter',
    DimensionFilter: 'dimensionfilter',
    MeasureFilter: 'measurefilter',
    /**
     * Checks whether the given object or type is a metadata element
     *
     * @param o - object to check
     * @returns true if the object or type is a metadata element
     */
    isMetadata(o) {
        return (exports.MetadataTypes.isMeasure(o) ||
            exports.MetadataTypes.isDimension(o) ||
            exports.MetadataTypes.isAttribute(o) ||
            exports.MetadataTypes.isFilter(o));
    },
    /**
     * Checks whether the given object or type is a measure template
     *
     * @param o - object to check
     * @returns true if the object or type is a measure template
     */
    isMeasureTemplate(o) {
        if (!o) {
            return false;
        }
        if (typeof o === 'string') {
            const type = o;
            return type.toLowerCase() === exports.MetadataTypes.MeasureTemplate;
        }
        return (o.agg === '*' ||
            o.aggregation === '*' ||
            (o.type && o.type.toLowerCase() === exports.MetadataTypes.MeasureTemplate));
    },
    /**
     * Checks whether the given object or type is a base measure
     *
     * @param o - object to check
     * @returns true if the object or type is a base measure
     */
    isBaseMeasure(o) {
        if (!o) {
            return false;
        }
        if (typeof o === 'string') {
            const type = o;
            return type.toLowerCase() === exports.MetadataTypes.BaseMeasure;
        }
        // JaqlElement doesn't have property attribute. Check for jaql instead
        return (o.agg || o.aggregation) && (o.attribute || o.jaql) && !this.isMeasureTemplate(o);
    },
    /**
     * Checks whether the given object or type is a measure - of any type
     *
     * @param o - object to check
     * @returns true if the object or type is a measure - of any type
     */
    isMeasure(o) {
        if (!o) {
            return false;
        }
        if (typeof o === 'string') {
            const type = o;
            return (type.toLowerCase() === exports.MetadataTypes.Measure ||
                type.toLowerCase() === exports.MetadataTypes.BaseMeasure ||
                type.toLowerCase() === exports.MetadataTypes.MeasureTemplate ||
                type.toLowerCase() === exports.MetadataTypes.CalculatedMeasure);
        }
        return this.isBaseMeasure(o) || this.isCalculatedMeasure(o) || this.isMeasureTemplate(o);
    },
    /**
     * Checks whether the given object or type is a calculated measure
     *
     * @param o - object to check
     * @returns true if the object or type is a calculated measure
     */
    isCalculatedMeasure(o) {
        if (!o) {
            return false;
        }
        if (typeof o === 'string') {
            const type = o;
            return type.toLowerCase() === exports.MetadataTypes.CalculatedMeasure;
        }
        return (o.expression || o.formula) && o.context;
    },
    /**
     * Checks whether the given object or type is a date dimension
     *
     * @param o - object to check
     * @returns true if the object or type is a date dimension
     */
    isDateDimension(o) {
        if (!o) {
            return false;
        }
        if (typeof o === 'string') {
            const type = o;
            return type.toLowerCase() === exports.MetadataTypes.DateDimension;
        }
        return (o.dim || o.expression) && o.level;
    },
    /**
     * Checks whether the given object or type is a text dimension
     *
     * @param o - object to check
     * @returns true if the object or type is a text dimension
     */
    isTextDimension(o) {
        if (!o) {
            return false;
        }
        if (typeof o === 'string') {
            const type = o;
            return type.toLowerCase() === exports.MetadataTypes.TextDimension;
        }
        return false;
    },
    /**
     * Checks whether the given object or type is a numeric dimension
     *
     * @param o - object to check
     * @returns true if the object or type is a numeric dimension
     */
    isNumericDimension(o) {
        if (!o) {
            return false;
        }
        if (typeof o === 'string') {
            const type = o;
            return type.toLowerCase() === exports.MetadataTypes.NumericDimension;
        }
        return false;
    },
    /**
     * Checks whether the given object or type is a dimension - of any type
     *
     * @param o - object to check
     * @returns true if the object or type is a dimension - of any type
     */
    isDimension(o) {
        if (typeof o === 'object') {
            o = o.type;
        }
        if (typeof o === 'string') {
            const type = o;
            return (type.toLowerCase() === exports.MetadataTypes.DateDimension ||
                type.toLowerCase() === exports.MetadataTypes.Dimension ||
                type.toLowerCase() === exports.MetadataTypes.TextDimension ||
                type.toLowerCase() === exports.MetadataTypes.NumericDimension);
        }
        return false;
    },
    /**
     * Checks whether the given object or type is an attribute - of any type
     *
     * @param o - object to check
     * @returns true if the object or type is an attribute - of any type
     */
    isAttribute(o) {
        if (typeof o === 'string') {
            const type = o;
            return (type.toLowerCase() === exports.MetadataTypes.Attribute ||
                type.toLowerCase() === exports.MetadataTypes.TextAttribute ||
                type.toLowerCase() === exports.MetadataTypes.NumericAttribute ||
                type.toLowerCase() === exports.MetadataTypes.DateLevel);
        }
        if (o && o.type) {
            return this.isAttribute(o.type);
        }
        return false;
    },
    /**
     * Checks whether the given object or type is a filter
     *
     * @param o - object to check
     * @returns true if the object or type is a filter
     */
    isFilter(o) {
        if (typeof o === 'object') {
            o = o.type;
        }
        if (typeof o === 'string') {
            const type = o;
            return (type.toLowerCase() === exports.MetadataTypes.Filter ||
                type.toLowerCase() === exports.MetadataTypes.DimensionFilter ||
                type.toLowerCase() === exports.MetadataTypes.MeasureFilter);
        }
        return false;
    },
};
/**
 * Levels for {@link DateDimension}
 */
exports.DateLevels = {
    Years: 'Years',
    Quarters: 'Quarters',
    Months: 'Months',
    Weeks: 'Weeks',
    Days: 'Days',
    Hours: 'Hours',
    MinutesRoundTo30: 'MinutesRoundTo30',
    MinutesRoundTo15: 'MinutesRoundTo15',
    Minutes: 'Minutes',
    Seconds: 'Seconds',
    AggHours: 'AggHours',
    AggMinutesRoundTo30: 'AggMinutesRoundTo30',
    AggMinutesRoundTo15: 'AggMinutesRoundTo15',
    AggMinutesRoundTo1: 'AggMinutesRoundTo1',
    /** @internal */
    get all() {
        return [
            exports.DateLevels.Years,
            exports.DateLevels.Quarters,
            exports.DateLevels.Months,
            exports.DateLevels.Weeks,
            exports.DateLevels.Days,
            exports.DateLevels.Hours,
            exports.DateLevels.MinutesRoundTo30,
            exports.DateLevels.MinutesRoundTo15,
            exports.DateLevels.Minutes,
            exports.DateLevels.Seconds,
            exports.DateLevels.AggHours,
            exports.DateLevels.AggMinutesRoundTo30,
            exports.DateLevels.AggMinutesRoundTo15,
            exports.DateLevels.AggMinutesRoundTo1,
        ];
    },
};
/** @internal */
var DataType;
(function (DataType) {
    DataType["TEXT"] = "text";
    DataType["NUMERIC"] = "numeric";
    DataType["DATETIME"] = "datetime";
})(DataType = exports.DataType || (exports.DataType = {}));
/** @internal */
var JaqlSortDirection;
(function (JaqlSortDirection) {
    JaqlSortDirection["ASC"] = "asc";
    JaqlSortDirection["DESC"] = "desc";
})(JaqlSortDirection = exports.JaqlSortDirection || (exports.JaqlSortDirection = {}));
/**
 * @internal
 */
var CurrencyPosition;
(function (CurrencyPosition) {
    CurrencyPosition["PRE"] = "pre";
    CurrencyPosition["POST"] = "post";
})(CurrencyPosition = exports.CurrencyPosition || (exports.CurrencyPosition = {}));
